import { ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { LessonUsageBarChart } from "../shared/LessonUsageBarChart";
import { LessonUsageRow } from "./adminUsageReportApiSlice";

export function LessonUsageChart(props: {
	level: ReportLevel;
	data: LessonUsageRow[];
	hasData: boolean;
}) {
	return (
		<LessonUsageBarChart
			data={props.data}
			hasData={props.hasData}
			title={`${reportSubLevelName(props.level)} Lesson Usage`}
			yAxisDataField="name"
			seriesName="Time Spent in Lessons"
		/>
	);
}
